import React__default from 'react';
import { useId, SelectionSet, SelectionSetInput, SelectionSetLabel, SelectionSetTileContents, Box, Typography, FlexBox, SelectionSetTileName, SelectionSetTilePrice } from '@vp/swan';
import { OptionPriceDisplay } from '../../../../shared/options-price-display/option-price-display.mjs';
import { SelectionSetTileCallouts } from '../callouts.mjs';
import { SelectionSetTileDescription } from '../description.mjs';
import { ImageTileThumbnail } from '../image-thumbnail.mjs';
import { SimpleTitle } from '../../../../shared/simple-title/simple-title.mjs';
import st from '../../../../../../../../../styled-components/dist/styled-components.esm.mjs';

const WideButtons = st.div `
  .swan-selection-set {
    flex-wrap: wrap;
  }

  .swan-selection-set.swan-selection-set-skin-tiles-horizontal .swan-callout {
    position: relative;
    top: unset;
    left: unset;
    margin-bottom: var(--swan-spacing-standard-1);
  }

  .swan-selection-set.swan-selection-set-skin-tiles-horizontal .swan-selection-set-label {
    word-break: initial;
    align-items: start;
  }

  .swan-selection-set.swan-selection-set-skin-tiles-horizontal .swan-selection-set-tile-contents {
    width: 100%;
  }
`;
const WideButtonSkin = ({ option, locale, currency, fractionDigits, onChanged, priceDisplayMode = "differential-unit", showIncompatibleChoices, hideImages, tenant, hideDescriptions, }) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const onChangeHandler = (selectedValue, event) => {
        onChanged({ choiceKey: selectedValue });
    };
    const titleId = useId();
    const optionChoicesToShow = option.choices.filter((choice) => showIncompatibleChoices || choice.isCompatible);
    return (React__default.createElement(WideButtons, null,
        React__default.createElement(SimpleTitle, { titleId: titleId }),
        React__default.createElement(SelectionSet, { variant: "single-select", skin: "tiles-horizontal", selectedValue: option.selectedKey, onSelectedValueChange: onChangeHandler, "aria-labelledby": titleId, "aria-required": option.isRequired }, optionChoicesToShow.map((choice, index) => (React__default.createElement(SelectionSetInput, { key: `choice_${choice.key}`, value: choice.key, disabled: !choice.isCompatible, id: option.key + choice.key },
            React__default.createElement(SelectionSetLabel, { mb: index === optionChoicesToShow.length - 1 ? 0 : undefined },
                !hideImages && React__default.createElement(ImageTileThumbnail, { choice: choice }),
                React__default.createElement(SelectionSetTileContents, { ml: { xs: 0, sm: 0, md: "5", lg: "5", xl: "5" } },
                    choice.callouts && choice.callouts.length > 0 && (React__default.createElement(Box, { mb: choice.experimental?.auto_upsell_1 && choice.experimental?.auto_upsell_2
                            ? "1"
                            : "3" },
                        React__default.createElement(SelectionSetTileCallouts, { callouts: choice.callouts }))),
                    !hideImages &&
                        choice.experimental?.auto_upsell_1 &&
                        choice.experimental?.auto_upsell_2 && (React__default.createElement(React__default.Fragment, null,
                        React__default.createElement(Typography, { fontSkin: "body-small" }, choice.experimental?.auto_upsell_1),
                        React__default.createElement(Typography, { fontSkin: "footnote", textColor: "subtle", mb: 3 }, choice.experimental?.auto_upsell_2))),
                    React__default.createElement(FlexBox, { justifyContent: "space-between", fontSize: "standard" },
                        React__default.createElement(SelectionSetTileName, null, choice.name),
                        priceDisplayMode === "none" || choice.key === option.selectedKey ? (React__default.createElement(React__default.Fragment, null)) : (React__default.createElement(SelectionSetTilePrice, { pl: "3" },
                            React__default.createElement(OptionPriceDisplay, { tenant: tenant, choice: choice, priceDisplayMode: priceDisplayMode, locale: locale, currency: currency, fractionDigits: fractionDigits, hideZeroPrice: true })))),
                    !hideDescriptions && (React__default.createElement(SelectionSetTileDescription, { descriptionMarkdown: choice.description }))))))))));
};

export { WideButtonSkin };
//# sourceMappingURL=wide-button-skin.mjs.map
